<script>
import OrdersApi from "@/services/orders-api";
import LocalInvoicesApi from "@/services/local-invoices-api";
import Swal from "sweetalert2";
import SuppliersApi from "@/services/suppliers-api";


export default {

    props: {
        isAllOrders : Boolean,
        showDrafts:{
          type: Boolean,
          default: false,
        },
        supplierId: Number,
        customerId: Number,
        reference: String,
        status:Number,

    },

    
    data () {
        return {

      allOrdersFields: [
        
        { key:"submissionDate", label: "Date",   sortable: false, tdClass:"font-weight-bold"},
        { key:"ref", label: "Numéro",thClass:"d-md-table-cell d-none",tdClass:"d-md-table-cell d-none" },
        { key:"supplier.name", label: "Fournisseur", tdClass:"font-weight-bold",},
        { key:"itemsCount", label: "Articles",   thClass:"text-right d-md-table-cell d-none", tdClass:"font-size-14 text-right d-md-table-cell d-none"},
        { key:"total", label: "Total HT",   thClass:"text-right d-md-table-cell d-none", tdClass:"text-right font-size-14 d-md-table-cell d-none",},
        { key:"totalWithTaxes", label: "Total TTC",   thClass:"text-right d-md-table-cell d-none", tdClass:"text-right font-size-14 d-md-table-cell d-none",},
        { key:"status", label: "Etat",  thClass:"text-center d-md-table-cell d-none", tdClass:"text-center d-md-table-cell d-none"},
        { key:"actions", label:"", tdClass: "text-right", thClass: "text-right", thStyle:"width:100px;"}
        ],

        singleSupplierFields: [
        
        { key:"submissionDate", label: "Date",   sortable: false, tdClass:"font-weight-bold",},
        { key:"ref", label: "Numéro",thClass:"d-md-table-cell d-none",tdClass:"d-md-table-cell d-none" },
        { key:"itemsCount", label: "Articles",   thClass:"text-right d-md-table-cell d-none", tdClass:"font-size-14 text-right d-md-table-cell d-none"},
        { key:"total", label: "Total HT",   thClass:"text-right d-md-table-cell d-none", tdClass:"text-right font-size-14 d-md-table-cell d-none",},
        { key:"totalWithTaxes", label: "Total TTC",   thClass:"text-right d-md-table-cell d-none", tdClass:"text-right font-size-14 d-md-table-cell d-none"},
        { key:"status", label: "Etat",   thClass:"text-center d-md-table-cell d-none", tdClass:"text-center d-md-table-cell d-none"},
        { key:"actions", label:"", tdClass: "text-right", thClass: "text-right", thStyle:"width:100px;"}
        ],

        forSupplierFields: [
        
        { key:"submissionDate", label: "Date", sortable: false, tdClass:"font-weight-bold"},
        { key:"ref", label: "Numéro",thClass:"d-md-table-cell d-none",tdClass:"d-md-table-cell d-none"},
        { key:"customer.name", label: "Client", tdClass:"font-weight-bold"},
        { key:"itemsCount", label: "Articles",   thClass:"text-right d-md-table-cell d-none", tdClass:"font-size-14 text-right d-md-table-cell d-none"},
        { key:"total", label: "Total HT",   thClass:"text-right d-md-table-cell d-none", tdClass:"text-right font-size-14 d-md-table-cell d-none",},
        { key:"totalWithTaxes", label: "Total TTC", thClass:"text-right d-md-table-cell d-none", tdClass:"text-right font-size-14 d-md-table-cell d-none"},
        { key:"status", label: "Etat",  thClass:"text-center d-md-table-cell d-none", tdClass:"text-center d-md-table-cell d-none"},
        { key:"actions", label:"", tdClass: "text-right", thClass: "text-right", thStyle:"width:100px;"}
        ],

        forAdminFields: [
        
        { key:"submissionDate", label: "Date", sortable: false, tdClass:"font-weight-bold"},
        { key:"ref", label: "Numéro",thClass:"d-md-table-cell d-none",tdClass:"d-md-table-cell d-none"},
        { key:"supplier.name", label: "Fournisseur", tdClass:"font-weight-bold",},
        { key:"customer.name", label: "Client", tdClass:"font-weight-bold"},
        { key:"itemsCount", label: "Articles",   thClass:"text-right d-md-table-cell d-none", tdClass:"font-size-14 text-right d-md-table-cell d-none"},
        { key:"total", label: "Total HT",   thClass:"text-right d-md-table-cell d-none", tdClass:"text-right font-size-14 d-md-table-cell d-none",},
        { key:"totalWithTaxes", label: "Total TTC", thClass:"text-right d-md-table-cell d-none", tdClass:"text-right font-size-14 d-md-table-cell d-none"},
        { key:"status", label: "Etat",  thClass:"text-center d-md-table-cell d-none", tdClass:"text-center d-md-table-cell d-none"},
        { key:"actions", label:"", tdClass: "text-right", thClass: "text-right", thStyle:"width:100px;"}
        ],

        pagemodel: {currentPage : 1, perPage : 10, totalRows: 0},

        ordersList: [],

        isTableLoading: false,

        role:null,

        selectedInvoiceOrder: null,

        isInvoiceSupportedBySupplier:false ,

        }

    },
    created (){
      this.getIsInvoiceSupported();
    },

    mounted () {
      this.role=sessionStorage.getItem("userr");
      this.getOrders();
  },

methods: {

    statusToLabel(order) {
      switch(order.status) {
        case 0: return 'Brouillon';
        case 1: return 'Nouvelle';
        case 2: return 'Confirmée';
        case 3: return order.isDeliveryDone ? 'Livré' : 'En cours de Livraison';
        case 4: return 'Annulée';
        default: return '';
      }
    },

    statusToColor(order) {
      switch(order.status) {
        case 0: return 'secondary';
        case 1: return 'danger';
        case 2: return 'warning'
        case 3: return order.isDeliveryDone ? 'success' : 'info';
        case 4: return 'secondary';
        default: return 'black';
      }
    },
        getOrders() {
      this.isTableLoading = true

      if (this.role==1) {
         OrdersApi.getOrders(this.pagemodel.currentPage, this.pagemodel.perPage, false,this.status,this.customerId, this.reference)
      .then(orders => {
        this.ordersList = orders.list
        this.pagemodel.totalRows = orders.total;
        this.pagemodel.currentPage = orders.page;
        this.pagemodel.perPage = orders.pageSize;
        this.pagemodel.pageSize = orders.pageSize;
      })
      .finally(() => {
        this.isTableLoading=false 
      })

      return;
      }

      if(this.role==0){

      OrdersApi.getOrdersByCustomer(this.pagemodel.currentPage, this.pagemodel.perPage,this.supplierId, false,null,this.status)
      .then(orders => {
        this.ordersList = orders.list
        this.pagemodel.totalRows = orders.total;
        this.pagemodel.currentPage = orders.page;
        this.pagemodel.perPage = orders.pageSize;
        this.pagemodel.pageSize = orders.pageSize;
      })

      .finally(() => {
        this.isTableLoading=false 
      })

      }

    if(this.role==2){

      OrdersApi.getAllOrders(this.pagemodel.currentPage, this.pagemodel.perPage,this.supplierId, this.customerId,this.status,false, this.reference)
      .then(orders => {
        this.ordersList = orders.list
        this.pagemodel.totalRows = orders.total;
        this.pagemodel.currentPage = orders.page;
        this.pagemodel.perPage = orders.pageSize;
        this.pagemodel.pageSize = orders.pageSize;
      })

      .finally(() => {
        this.isTableLoading=false 
      })

      }

 

    },
    getIsInvoiceSupported() { 
      SuppliersApi.getIsInvoiceSupported() 
      .then(isInvoiceSupportedBySupplier => {
          this.isInvoiceSupportedBySupplier = isInvoiceSupportedBySupplier;
        })
    },

    convertToInvoice(order) {

      if (!order) {
        return;
      }

      this.selectedInvoiceOrder = order.id;
      
      Swal.fire({
        title: "Facturer ?",
        html: 'La commande ' + order.ref,
        icon: "info",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        cancelButtonText: "Annuler",
        confirmButtonText: "Oui, facturer!"
      }).then(result=>{
        if(result.value){  
          this.confirmConvertToInvoice();
        }
      }
          )
    },

    confirmConvertToInvoice() {

        if (!this.selectedInvoiceOrder) {
          return;
        }

        OrdersApi.convertOrder(this.selectedInvoiceOrder).then(
          (localInvoice)=>{
            if(localInvoice){
              
              this.getOrders();

              Swal.fire({
                  title: "Partager avec le client ?",
                  html: 'Envoyer la facture ' + localInvoice.ref + ' que vous venez de générer au client ?',
                  icon: "info",
                  showCancelButton: true,
                  confirmButtonColor: "#34c38f",
                  cancelButtonColor: "#f46a6a",
                  cancelButtonText: "Non, plus tard",
                  confirmButtonText: "Oui, envoyer!"
              }).then(result=>{
                if(result.value){

                    this.shareInvoiceWithCustomer(localInvoice.id);
                    OrdersApi.saveInvoice().then(
                    (result)=>{
                      if(result){
                        this.getInvoices()
                        this.selectedInvoice={id:null,title:'',name:'',deadlines:[],formattedDate:'',withholding:'', customer:null,invoiceNumber:''};
                        this.showModal=false
                        this.selectedPDF=null
                      }
                    }
                    )}
                  })
            }
          }
      )
    },

    shareInvoiceWithCustomer(localInvoiceId) {
      if (!localInvoiceId) {
        return;
      }
      LocalInvoicesApi.shareWithCustomer(localInvoiceId).then(
        (result)=>{
          if(result){
            this.getOrders();
          }
        }
      )
    },

},

          watch: {
    supplierId : function(){
      this.getOrders()
    },

    customerId: function(){
      this.getOrders()
    },

    reference: function(){
      this.getOrders()
    },

    status: function(){
      this.getOrders()
    },


},




  };


</script>
<template>
<div>
    <div class="table-responsive mt-3" style="min-height:45em">        
        <b-table 
        :busy="isTableLoading"
        :striped="true"

        :small="false"
        :hover="true"

        :items="ordersList"
        :fields="role==1 ? forSupplierFields : (role==2 ? forAdminFields : (isAllOrders ? allOrdersFields : singleSupplierFields)) "

        :perPage="pagemodel.perPage"
        class="table  "
        >
        <template v-slot:table-busy>
        <div class="text-center my-2">
            <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
        </div>
        </template>

        <template v-slot:cell(actions)="{item}">
            <a v-if="isInvoiceSupportedBySupplier  && item.linesCount != 0 && !item.isInvoiced" @click="convertToInvoice(item)" href="javascript:void(0);"  class="action-icon font-size-16 text-primary mr-2"><i v-b-tooltip.hover title="Facturer" class="far fa-file-alt pr-2 font-size-24"></i></a>

            <router-link :to="{ path: '/orders/order', query: { orderId: item.id }}">
            <a v-if="item.linesCount != 0" href="javascript:void(0);"  class="action-icon font-size-16 text-primary mr-2"><i v-b-tooltip.hover title="Ouvrir" class="fas fa-file-import font-size-24 text-primary"></i></a>
        </router-link>
        </template>

        <template v-slot:cell(status)="{item}">
        <h5><b-badge href="#" :variant="statusToColor(item)">{{statusToLabel(item)}}</b-badge></h5>
        </template>

        <template v-slot:cell(ref)="{item,value}">
        <span :class="item.status ==0 ? 'text-danger' : ''">{{value}}</span>
        </template>

        <template v-slot:cell(submissionDate)="{item,value}">
        <span v-if="item.status == 0" class="text-danger"><i class="mdi mdi-clock-outline mr-2"></i>Brouillon ({{ item.date }})</span>
        <span v-if="item.submissionDate">{{value}}</span>
        </template>
        </b-table>
        <span v-if="!isTableLoading && !ordersList.length" class="d-flex justify-content-center m-4 text-danger" >Aucune commande dans la liste</span>

       



    </div> 
    <div>
    <!-- Pagination -->
        <div class="row pt-3 mb-sm-4">
            <div class="col-sm-8">
                <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                    <b-form-select @input="getOrders()"  v-model="pagemodel.perPage" size="sm" style="width: 60px" :options="[10,15,50,100]"></b-form-select>
                    <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">sur</span><span class="font-weight-bold"> {{pagemodel.totalRows}} lignes</span></div>
                </div>
            </div>
            <div class="col-sm-4">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                    <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="pagemodel.currentPage" :disabled="isTableLoading" :per-page="pagemodel.pageSize" :total-rows="pagemodel.totalRows" @input="getOrders()" ></b-pagination>
                    </ul>
                </div>
            </div>
        </div> 
        <!-- Fin Pagination  -->
 </div>
 </div>
</template>                 
               